import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./mybooking.module.css";
import { MenuItem, Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, Snackbar, Alert, Button, DialogActions } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Calendar, X, Mail as MailIcon, AlertTriangle } from "react-feather";
import axios from "axios";
import { authData, withCustomerAuth } from "../../../admin/components/GetAuth";
import Loader from "../../../admin/components/Loader";
import SideBar from "../../components/sideBar";
import { MyBookingLoader } from "../../components/ContentLoader";
import { DateRangePicker } from "rsuite";
import dayjs from "dayjs";
import BookingBlock from "./components/BookingBlock";
import BookingDetailsPopup from "./components/bookingDetailsPopup";
import download from "downloadjs";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import TablePaginationComponent from "../../components/TablePagination";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";

const MyBookings = () => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [bookingList, setBookingList] = useState([]);
  const [allBookingList, setAllBookingList] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", status: "", date: null });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [viewModalOpen, setViewModalOpen] = useState();
  const [viewId, setViewId] = useState(0);
  const [viewStr, setViewStr] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [sendInvoiceModalOpen, setSendInvoiceModalOpen] = useState(false);
  const [invoiceMailId, setInvoiceMailId] = useState(0);
  const [invoiceMail, setInvoiceMail] = useState("");
  const [cancelModalOpen, setCancelModalOpen] = useState();
  const [cancelId, setCancelId] = useState(0);

  const { websiteData } = useWebsite();
  useSiteBranding("My booking", websiteData);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "v1/customer/customer-booking-list", {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        },
      })
      .then((response) => {
        setContentLoading(false);
        if (response.data.status === "SUCCESS") {
          setAllBookingList(response?.data.data);
        }
      })
      .catch(() => {
        setContentLoading(false);
      });
  }, [auth?.api_token]);

  useEffect(() => {
    let allBookingListTemp = allBookingList;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey.toLowerCase();
      allBookingListTemp = allBookingListTemp.filter((item) => {
        return (
          item.booking_id.toLowerCase().includes(inputVal) ||
          item.customer_name.toLowerCase().includes(inputVal) ||
          item.post_code.toLowerCase().includes(inputVal) ||
          item.created_user.toLowerCase().includes(inputVal)
        );
      });
    }

    if (filterVars?.status !== "" && filterVars?.status !== "all") {
      let status = parseInt(filterVars?.status);
      allBookingListTemp = allBookingListTemp.filter((i) => parseInt(i?.status) === status);
    }

    if (filterVars?.date) {
      allBookingListTemp = allBookingListTemp.filter((i) =>
        dayjs(i?.booking_date).isBetween(
          dayjs(filterVars?.date[0]).format("YYYY-MM-DD"),
          dayjs(filterVars?.date[1]).format("YYYY-MM-DD"),
          "day",
          "[]"
        )
      );
    }

    setBookingList(allBookingListTemp);
  }, [allBookingList, filterVars]);

  const sendMailBooking = () => {
    setSendInvoiceModalOpen(false);
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/send-booking-pdf/" + invoiceMailId, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      },
    })
      .then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const printBooking = (id) => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/bookings-item-pdf/" + id, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      },
    })
      .then((response) => {
        setLoading(false);
        const content = response.headers["content-type"];
        download(response.data, "booking-" + id + ".pdf", content);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const cancelBooking = () => {
    setLoading(true);
    setCancelModalOpen(false);

    axios
      .put(
        process.env.REACT_APP_API_URL + "v1/bookings/" + cancelId,
        { status: -1 },
        {
          headers: {
            Authorization: `Bearer ${auth?.api_token}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage("Booking cancelled successfully.");
          setSnackbarType("success");

          setAllBookingList((prev) =>
            prev.map((i) => (i?.id === cancelId ? { ...i, status: -1 } : i))
          );

          setCancelId(0);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }

  return (
    <>
      <Loader open={loading} setOpen={setLoading} />

      <div className={`${styles.MainDivCustomer}`}>
        <div className={`${styles.Container}`}>
          <div className={`${styles.CusRow}`}>
            <div className={`${styles.CustomerSideBar}`}>
              <SideBar />
            </div>
            <div className={`${styles.CustomerDeSec}`}>
              <div className={`${styles.UserProCard2}`}>
                {contentLoading && <MyBookingLoader />}

                {!contentLoading && (
                  <div className={`${styles.BookingCard}`}>
                    <div className={styles.PageHead}>
                      <div>
                        <h1 className={styles.PageHeadTitle}>My bookings</h1>
                        <p className={styles.PageHeadCount}>
                          {bookingList?.length} booking{bookingList?.length === 1 ? "" : "s"}
                        </p>
                      </div>
                    </div>

                    <div className={styles.FilterBar}>
                      <div className={`${styles.BookListSearch}`}>
                        <input
                          type="text"
                          placeholder="Search by ID, name, or postcode"
                          value={filterVars?.searchKey}
                          onChange={(e) => setFilterVars((prev) => ({ ...prev, searchKey: e.target.value }))}
                        />
                        {filterVars?.searchKey !== "" && (
                          <button type="button" onClick={() => setFilterVars((prev) => ({ ...prev, searchKey: "" }))}>
                            <Close />
                          </button>
                        )}
                      </div>

                      <div className={styles.FilterSelect}>
                        <FormControl fullWidth>
                          <InputLabel>Filter by status</InputLabel>
                          <Select
                            value={filterVars?.status}
                            label="Filter by status"
                            onChange={(e) => setFilterVars((prev) => ({ ...prev, status: e.target.value }))}
                          >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={-1}>Order cancelled — UK</MenuItem>
                            <MenuItem value={0}>Order booked — UK</MenuItem>
                            <MenuItem value={1}>Item assigned to driver — UK</MenuItem>
                            <MenuItem value={2}>Item picked up — UK</MenuItem>
                            <MenuItem value={3}>Item in warehouse — UK</MenuItem>
                            <MenuItem value={4}>Item shipped from warehouse — UK</MenuItem>
                            <MenuItem value={9}>Item received at port — Ghana</MenuItem>
                            <MenuItem value={5}>Item received in warehouse — Ghana</MenuItem>
                            <MenuItem value={6}>Item out for delivery — Ghana</MenuItem>
                            <MenuItem value={8}>Partially delivered — Ghana</MenuItem>
                            <MenuItem value={7}>Delivered — Ghana</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      <div className={styles.FilterDate}>
                        <DateRangePicker
                          format={"dd/MM/yyyy"}
                          placement={"bottomEnd"}
                          placeholder="Search by date"
                          caretAs={Calendar}
                          value={filterVars?.date}
                          showOneCalendar
                          block
                          onChange={(e) => setFilterVars((prev) => ({ ...prev, date: e }))}
                        />
                      </div>
                    </div>

                    {bookingList?.length > 0 && (
                      <div className={styles.BookingTable}>
                        <div className={styles.TableHead}>
                          <span className={styles.TableHeadCell}>Booking</span>
                          <span className={styles.TableHeadCell}>Status</span>
                          <span className={styles.TableHeadCell}>Date</span>
                          <span className={styles.TableHeadCell}>Total</span>
                          <span className={styles.TableHeadCell}>Due</span>
                          <span />
                        </div>

                        {bookingList
                          ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          ?.map((item, index) => (
                            <BookingBlock
                              key={index}
                              item={item}
                              setViewModalOpen={setViewModalOpen}
                              setViewId={setViewId}
                              setViewStr={setViewStr}
                              setSendInvoiceModalOpen={setSendInvoiceModalOpen}
                              setInvoiceMailId={setInvoiceMailId}
                              setInvoiceMail={setInvoiceMail}
                              printBooking={printBooking}
                              setCancelId={setCancelId}
                              setCancelModalOpen={setCancelModalOpen}
                            />
                          ))}
                      </div>
                    )}

                    {bookingList?.length > 0 && (
                      <TablePaginationComponent
                        count={bookingList?.length}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        colSpan={6}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        handleChangePage={paginationChangePage}
                        handleChangeRowsPerPage={paginationChangeRowsPerPage}
                      />
                    )}

                    {bookingList?.length === 0 && (
                      <div className={`${styles.NofileSec}`}>
                        <div className={`${styles.NofileSecUnder}`}>
                          <img src="/images/no-connection.png" alt="" />
                          <p>
                            {allBookingList?.length === 0
                              ? "You're all set to ship your first item"
                              : "No bookings match your filters"}
                          </p>
                          <span className={styles.NofileSub}>
                            {allBookingList?.length === 0
                              ? "Once you book a shipment, you'll be able to track it right here."
                              : "Try adjusting your search, status, or date range."}
                          </span>
                          {allBookingList?.length === 0 && (
                            <Link to="/customer/add-booking" className={styles.NofileCTA}>
                              Add a booking
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        fullWidth
        maxWidth="md"
        open={viewModalOpen}
        onClose={() => setViewModalOpen(false)}
        PaperProps={{ className: styles.ModalPaper }}
      >
        <DialogTitle className={styles.ModalHead} component="div">
          <div className={styles.ModalHeadText}>
            <p className={styles.ModalEyebrow}>Order</p>
            <h2 className={styles.ModalTitle}>#{viewStr}</h2>
          </div>
          <button className={styles.ModalCloseBU} onClick={() => setViewModalOpen(false)} aria-label="Close">
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={styles.ModalBody}>
          <BookingDetailsPopup bookingId={viewId} />
        </DialogContent>
      </Dialog>

      <Dialog
        open={sendInvoiceModalOpen}
        onClose={() => setSendInvoiceModalOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ className: styles.ModalPaper }}
      >
        <DialogTitle className={styles.ModalHead} component="div">
          <div className={styles.ModalHeadText}>
            <p className={styles.ModalEyebrow}>Invoice</p>
            <h2 className={styles.ModalTitle}>Send invoice?</h2>
          </div>
          <button className={styles.ModalCloseBU} onClick={() => setSendInvoiceModalOpen(false)} aria-label="Close">
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={styles.ModalBody}>
          <div className={`${styles.ModalIconWrap} ${styles.Brand}`}>
            <MailIcon size={20} />
          </div>
          <p className={styles.ModalText}>
            We'll email a copy of this booking's invoice to <strong>{invoiceMail}</strong>.
          </p>
        </DialogContent>
        <DialogActions className={styles.ModalActions}>
          <Button className={styles.ModalBtnGhost} onClick={() => setSendInvoiceModalOpen(false)}>
            Cancel
          </Button>
          <Button className={styles.ModalBtnPrimary} onClick={sendMailBooking}>
            Send invoice
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={cancelModalOpen}
        onClose={() => setCancelModalOpen(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{ className: styles.ModalPaper }}
      >
        <DialogTitle className={styles.ModalHead} component="div">
          <div className={styles.ModalHeadText}>
            <p className={styles.ModalEyebrow}>Booking</p>
            <h2 className={styles.ModalTitle}>Cancel this booking?</h2>
          </div>
          <button className={styles.ModalCloseBU} onClick={() => setCancelModalOpen(false)} aria-label="Close">
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={styles.ModalBody}>
          <div className={`${styles.ModalIconWrap} ${styles.Danger}`}>
            <AlertTriangle size={20} />
          </div>
          <p className={styles.ModalText}>This can't be undone. The booking will be marked as cancelled.</p>
        </DialogContent>
        <DialogActions className={styles.ModalActions}>
          <Button className={styles.ModalBtnGhost} onClick={() => setCancelModalOpen(false)}>
            Keep booking
          </Button>
          <Button className={styles.ModalBtnDanger} onClick={cancelBooking}>
            Cancel booking
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default withCustomerAuth(MyBookings);